import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { EdpOverlayBenefitsComponent } from "./edp-overlay-benefits.component";
import { EdpPartnershipsModule } from "./edp-partnerships/edp-partnerships.module";
import { EdpSavingsModule } from "./edp-savings/edp-savings.module";
import { EdpLoaderModule } from "@edp-components/edp-loader/edp-loader.module";

@NgModule({
    declarations: [EdpOverlayBenefitsComponent],
    imports: [CommonModule, TranslateModule, EdpSavingsModule, EdpPartnershipsModule, EdpLoaderModule],
    exports: [EdpOverlayBenefitsComponent],
})
export class EdpOverlayBenefitsModule {}
